import React from 'react';

// Resalta los signos de pregunta del título (compartido por las variantes).
export const renderTitleWithStyledQuestionMarks = (title, id) =>
  title.split('').map((char, index) =>
    char === '?' || char === '¿' ? (
      <span key={`${char}-${index}`} className={`home-onboarding-question ${id}`}>
        {char}
      </span>
    ) : (
      char
    )
  );

export default renderTitleWithStyledQuestionMarks;
